/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AccountType = {
    CASH: 'CASH',
    BANK_ACCOUNT: 'BANK_ACCOUNT'
} as const;
export type AccountType = typeof AccountType[keyof typeof AccountType];

